import React from 'react';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { UserAccessErrorModal } from './UserAccessErrorModal';
import { LimitedAccessModal } from './LimitedAccessModal';

export const PermissionsModal = () => {
  const { user } = useUser.state();
  const { code } = user;
  const { getErrorMessage } = usePPDLagoon();
  const lagoonErrTitle = code
    ? getErrorMessage(`ds-user-permission-title[${code}]`)
    : '';

  const modalProps = {
    title: lagoonErrTitle,
    message: user?.message || '',
    code: user.code || '',
  };

  return (
    <React.Fragment>
      <Choose>
        <When condition={code && getFeature('OOPS_MODAL_REDESIGN')}>
          <UserAccessErrorModal {...modalProps} />
        </When>
        <Otherwise>
          <LimitedAccessModal />
        </Otherwise>
      </Choose>
    </React.Fragment>
  );
};
